import React from 'react';
import { Chip } from '@mui/material';

interface StatusChipProps {
  status: number | boolean | string;
  activeLabel?: string;
  inactiveLabel?: string;
  isOrder?: boolean;
}

// Define order status labels and colors
const orderStatusMap: Record<number, { label: string; color: string; bgColor: string }> = {
  1: { label: 'PENDING', color: '#f57c00', bgColor: '#fff3e0' },               // amber
  2: { label: 'IN PROCESS', color: '#1976d2', bgColor: '#e3f2fd' },            // blue
  5: { label: 'COMPLETED', color: '#2e7d32', bgColor: '#e8f5e9' },             // green
  7: { label: 'CANCELLED', color: '#b71c1c', bgColor: '#ffebee' },             // red
  8: { label: 'ON HOLD', color: '#f9a825', bgColor: '#fff8e1' },               // yellow darken
  9: { label: 'CANCELLED - POINTS REVERSED', color: '#d32f2f', bgColor: '#ffebee' },
  10: { label: 'FAILED', color: '#c62828', bgColor: '#ffebee' },
  11: { label: 'REFUNDED', color: '#0288d1', bgColor: '#e0f7fa' },             // light blue
  12: { label: 'REVERSED', color: '#0288d1', bgColor: '#e0f7fa' },
  13: { label: 'CHARGEBACK', color: '#d32f2f', bgColor: '#ffebee' },
  14: { label: 'EXPIRED', color: '#b71c1c', bgColor: '#ffebee' },
  15: { label: 'PROCESSED', color: '#388e3c', bgColor: '#e8f5e9' },            // green darken
  16: { label: 'VOIDED', color: '#d32f2f', bgColor: '#ffebee' },
  17: { label: 'OUT OF STOCK', color: '#fbc02d', bgColor: '#fff8e1' },         // yellow lighten
  18: { label: 'CLIENT REVERT PENDING', color: '#f57c00', bgColor: '#fff3e0' },
  19: { label: 'PARTIALLY COMPLETE', color: '#0288d1', bgColor: '#e0f7fa' },
  20: { label: 'REDEEMED', color: '#2e7d32', bgColor: '#e8f5e9' },
  21: { label: 'PARTIAL CANCEL - POINTS BACK', color: '#f9a825', bgColor: '#fff8e1' },
  22: { label: 'PARTIALLY REFUNDED', color: '#0288d1', bgColor: '#e0f7fa' },
};


const StatusChip: React.FC<StatusChipProps> = ({
  status,
  activeLabel = 'Active',
  inactiveLabel = 'Inactive',
  isOrder = false,
}) => {
  if (isOrder && typeof status === 'number' && orderStatusMap[status]) {
    const { label, color, bgColor } = orderStatusMap[status];
    return (
      <Chip
        label={label}
        size="small"
        sx={{
          bgcolor: bgColor,
          color,
          fontWeight: 600,
          borderRadius: 1.5,
          fontSize: '.65rem',
          letterSpacing: 0.6,
          textTransform: 'uppercase',
          height: 24,
          px: 1.2,
        }}
      />
    );
  }

  // Default boolean-style status chip
  const isActive = status === 1 || status === true || status === 'active';

  return (
    <Chip
      label={(isActive ? activeLabel : inactiveLabel).toString().toUpperCase()}
      size="small"
      sx={
        isActive
          ? {
              bgcolor: '#e6f0e0',
              color: '#2e7d32',
              fontWeight: 600,
              borderRadius: 1.5,
              fontSize: '.65rem',
              letterSpacing: 0.6,
              textTransform: 'uppercase',
              height: 24,
              px: 1.2,
            }
          : {
              bgcolor: '#fbeaea',
              color: '#b71c1c',
              fontWeight: 600,
              borderRadius: 1.5,
              fontSize: '.65rem',
              letterSpacing: 0.6,
              textTransform: 'uppercase',
              height: 24,
              px: 1.2,
            }
      }
    />
  );
};

export default StatusChip;
